import { EventbriteOrder, SingleEvent } from "./auth/enrich_user_data"

export type FilteredOrders = Pick<EventbriteOrder, "id" | "event_id"> &
  Pick<
    SingleEvent,
    | "name"
    | "description"
    | "online_event"
    | "start"
    | "status"
    | "refund_policy"
  >

export const filterOrderData = (
  orders: EventbriteOrder[]
): FilteredOrders[] => {
  return orders
    .filter((order): order is EventbriteOrder & { event: SingleEvent } =>
      Boolean(order?.event)
    )
    .map((order) => ({
      event_id: order.event_id,
      id: order.id,
      description: order.event.description,
      name: order.event.name,
      online_event: order.event.online_event,
      start: order.event.start,
      status: order.event.status,
      refund_policy: order.event.refund_policy
    }))
}
